import { initAppInsights, reactPlugin, withAITracking } from '@utils/AppInsights';
import { getToken, getUser } from '@utils/tokenStorage';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { Routing } from './routing';
import { getStore, history } from './store/configureStore';
import Global from './styles/global';

const token = getToken();
const user = getUser();
const initialState = { auth: { token, email: user } };

export const store = getStore(initialState);

initAppInsights({ history });

const TrackedApp = withAITracking(reactPlugin, () => (
  <HelmetProvider>
    <Global />
    <Provider store={store}>
      <Routing />
    </Provider>
  </HelmetProvider>
));

const App = ({ isCustomDomain, username }) => <TrackedApp isCustomDomain={isCustomDomain} username={username} />;

// const App = () => (
//   <>
//     <Global />
//     <Provider store={store}>
//       <Routing />
//     </Provider>
//   </>
// );

export default App;
